import React, { useEffect, useState } from 'react'
import SimpleImageSlider from "react-simple-image-slider";
function Bannerslider() {

    const images = [

        {
            url: "assets_web/images/banner/banner-1.jpeg",
            heading: "Welcome to Annapurna",
            text: "Pure, Healthy, Natural Just the Way Nature Intended",
             buttonText: "Shop Now"

        },
        {
            url: "assets_web/images/banner/banner-2.jpeg",
          heading: "Welcome to Annapurna",
             text: "Pure, Healthy, Natural Just the Way Nature Intended",
             buttonText: "Explore Offers"
        },
        {
            url: "assets_web/images/banner/banner-3.jpeg",
            heading: "Welcome to Annapurna",
           text: "Pure, Healthy, Natural Just the Way Nature Intended",
            buttonText: "Explore Offers"
        },
         
    ];

    const [currentIndex, setCurrentIndex] = useState(0);

    const onSlideChange = (index) => {
        setCurrentIndex(index - 1);
    };
  return (
    <>
     <div className="slider-container ">
        <div className="responsive-slider">
                <SimpleImageSlider
                    
                    width="100%"
                    height={window.innerWidth < 768 ? 250 : 600}
                    images={images.map(img => ({ url: img.url }))}
                    showBullets={false}
                    showNavs={true}
                    onStartSlide={onSlideChange}
                    autoPlay={true} 
                    autoPlayDelay={3.0} 
                />
                </div>
                <div className='caption'>
                <div className="slider-overlay banner">
                    <h2>{images[currentIndex].heading}</h2>
                    <p>{images[currentIndex].text}</p>
                    {/* <button className='theme-btn-one'>{images[currentIndex].buttonText}</button> */}
                </div>
                </div>
            </div>
    </>
  )
}

export default Bannerslider